import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import ReactGA from "react-ga4";

import NavBar from "./components/common/navBar";
import Footer from "./components/common/footer";

import HomePage from "./pages/HomePage";
import ProjectsPage from "./pages/ProjectsPage";
import ResearchPage from "./pages/ResearchPage";
import InterestsPage from "./pages/InterestsPage";
import ExperiencePage from "./pages/ExperiencePage";
import ContactPage from "./pages/ContactPage";
import MessagesPage from "./pages/MessagesPage";

import SEO from "./data/seo";
import { TRACKING_ID } from "./data/tracking";
import "./app.css";

function App() {
	useEffect(() => {
		if (TRACKING_ID !== "") {
			ReactGA.initialize(TRACKING_ID);
		}
	}, []);

	return (
		<div className="App">
			<Helmet>
				<title>{SEO.title}</title>
				<meta name="description" content={SEO.description} />
				<meta name="keywords" content={SEO.keywords.join(", ")} />
			</Helmet>

			<NavBar />

			<main className="page-content">
				<Routes>
					<Route path="/" element={<HomePage />} />
					<Route path="/projects" element={<ProjectsPage />} />
					<Route path="/research" element={<ResearchPage />} />
					<Route path="/interests" element={<InterestsPage />} />
					<Route path="/experience" element={<ExperiencePage />} />
					<Route path="/contact" element={<ContactPage />} />
					<Route path="/messages" element={<MessagesPage />} />
				</Routes>
			</main>

			<Footer />
		</div>
	);
}

export default App;
